import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 6l-12 12","key":"svg-0"}],["path",{"d":"M6 6l12 12","key":"svg-1"}]]

const IconX = createReactComponent('outline', 'x', 'X', __iconNode);

export default IconX;